// extracted by mini-css-extract-plugin
export default {"chooseRole":"ChooseRole_chooseRole__O1nTh"};